export const analyticsIntervalTypes = ['custom', 'day', 'past 7 days', 'week', 'past month', 'month', 'year']
type AnalyticsInterval = (typeof analyticsIntervalTypes)[number]

export default AnalyticsInterval